<template>
  <v-overlay :value="loading" z-index="1000" :opacity="opacity">
    <v-progress-circular indeterminate size="64"></v-progress-circular>
  </v-overlay>
</template>

<script>
export default {
  name: "FullScreenLoading",

  props: {
    loading: Boolean,
    opacity: {
      type: Number,
      default: 0.5
    }
  }
};
</script>
